const constants = {
  url: 'https://jorisanwaterfrontresort.com/',
  title: 'Jorisan Waterfront Resort — Beach Resort, Hotel and Restaurant in Bauang, La Union',
  description:
    'Jorisan Waterfront Resort. Pagdalagan Sur, Bauang, La Union, Philippines. (+072) 682-9609 | (+072) 682-9609 | jorisan.wfresort@yahoo.com',
};

export default constants;
